const authorConfig = {
  name: "Jake Jarvis",
  email: "jake@jarv.is",
  social: {
    github: "jakejarvis",
    twitter: "jakejarvis",
    facebook: "jakejarvis",
    medium: "jakejarvis",
    linkedin: "jakejarvis",
    instagram: "jakejarvis",
    mastodon: "fediverse.jarv.is/@jake",
    bluesky: "jarv.is",
  },
} as const;

export default authorConfig;
